import {FC, ReactNode} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type ClassAssistClassOverviewSectionProps = {
  title: string
  description?: string | ReactNode
}

export const ClassAssistClassOverviewSection: FC<
  React.PropsWithChildren<ClassAssistClassOverviewSectionProps>
> = ({title, description, children}) => (
  <>
    <div className="wrapper">
      <Text variant={TextVariant.h3}>{title}</Text>
      {description && (
        <div className="description">
          <Text>{description}</Text>
        </div>
      )}
      <div className="content">{children}</div>
    </div>

    <style jsx>{`
      .wrapper {
        margin-top: ${theme.spacing[6]};
      }
      .description {
        margin-top: ${theme.spacing[3]};
      }
      .content {
        margin-top: ${theme.spacing[4]};
      }
      @media ${MOBILE_SCREENSIZE} {
        .wrapper + .wrapper {
          margin-top: ${theme.spacing[7]};
        }
      }
    `}</style>
  </>
)
